import { useQuery } from '@tanstack/react-query';

import { getRecentActivity } from '../api';
import { usersQueryKeys } from '../data';
import { useEditUserId, useUsersFilter, useUsersPagination } from '../store';
import { useGetUser } from './use-get-user';

export const useGetRecentActivity = () => {
  const userId = useUsersFilter().userId || useEditUserId();

  const recentActivityQuery = useQuery({
    queryKey: [...usersQueryKeys.getRecentActivity, userId],
    queryFn: getRecentActivity.bind(null, { userId }),
    enabled: Boolean(userId),
    staleTime: 5_000,
  });

  return recentActivityQuery;
};
